import { Box, Image, Text } from '@chakra-ui/react';
import AppCard from 'presentation/components/shared/card/AppCard';
import { FC } from 'react';

interface Props {
  preview: string;
  title: string;
  subtitle: string;
}

const EventDetailPreview: FC<Props> = ({ preview, title, subtitle }) => {
  const height = '155px';

  return (
    <AppCard pos="relative" h={height} overflow="hidden">
      <Image
        src={preview}
        zIndex="1"
        w="100%"
        h={height}
        pos="absolute"
        top="0"
        left="0"
        objectFit="cover"
      />
       <Box
        zIndex="2"
        pos="absolute"
        h={height}
        w="full"
        bgImage="linear-gradient(181.93deg,rgba(57,57,57,0) 1.63%,hsla(0,0%,7%,.7) 67.7%)"
        borderRadius="16px"
      />
      <Box
        pos="relative"
        zIndex="3"
        display="flex"
        flexDir="column"
        justifyContent="flex-end"
        py="15px"
        px="20px"
        h="100%"
        w="330px"
      >
        <Text fontSize="22px" mb="2px" color="#fff" fontWeight={800}>
          {title}
        </Text>
        <Text color="#fff">{subtitle}</Text>
      </Box>
    </AppCard>
  );
};

export default EventDetailPreview;
